import { Fragment } from "react";
import EmployeeItem from "./EmployeeItem";
import LoadingSkeleton from "../UI/LoadingSkeleton";

export default function EmployeeList({ onOpen, list, loading }) {
  const data = [1, 1, 1, 1, 1, 1];
  return (
    <Fragment>
      {loading ? (
        <>
          {data.map((el, i) => (
            <LoadingSkeleton key={i} lines={1} />
          ))}
        </>
      ) : (
        <>
          {list?.map((item, i) => (
            <EmployeeItem
              path="employees"
              item={item}
              key={i}
              onOpen={onOpen}
            />
          ))}
        </>
      )}
    </Fragment>
  );
}
